import { createContext, useContext } from 'react';

import type { JoyrideContextValue } from 'app/joyride/Joyride';

export const JoyrideContext = createContext<JoyrideContextValue>({
    currentTour: undefined,
    joyrideTours: [],
    loadCurrentTour: (startControl: string) => {

        console.log(`Taking the ${startControl} and setting it as the currentTour.`);

    }
});

JoyrideContext.displayName = 'JoyrideContext';

export const useJoyride = () => useContext(JoyrideContext);
